import { render, staticRenderFns } from "./HeadTable.vue?vue&type=template&id=16022710&scoped=true"
import script from "./HeadTable.vue?vue&type=script&lang=js"
export * from "./HeadTable.vue?vue&type=script&lang=js"
import style0 from "./HeadTable.vue?vue&type=style&index=0&id=16022710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16022710",
  null
  
)

export default component.exports